export const FONTS = ['JetBrains Mono', 'Inter', 'Space Mono', 'Orbitron', 'Rajdhani', 'Chakra Petch', 'Audiowide', 'Press Start 2P', 'Exo 2', 'Sora', 'Outfit', 'Unbounded', 'Bebas Neue', 'Poppins', 'Montserrat', 'Playfair Display', 'IBM Plex Sans', 'Fira Code'];

export const DEFAULT_BRAND = {
  name: 'Nexora',
  tagline: 'AI Game Foundry',
  heroTitle: "Giochi forgiati dall'IA.",
  heroText: 'Arcade HTML5 con effetti, suoni sintetizzati e controlli touch. Nessun download: tocca e gioca.',
  heroLabel: 'ARCADE',
  footerText: 'Installa l\'app sulla Home: i giochi aperti restano giocabili offline.',
  primary: '#8b5cf6',
  accent: '#06b6d4',
  background: '#030712',
  surface: '#0b1122',
  border: '#2a2350',
  copyright: '',
  logoIcon: '',
  fontDisplay: 'JetBrains Mono',
  fontUi: 'JetBrains Mono',
  fontText: 'Inter',
};

export const PRESETS = [
  { name: 'Neon Cyberpunk', primary: '#8b5cf6', accent: '#06b6d4', background: '#030712', surface: '#0b1122', border: '#2a2350' },
  { name: 'Retro Arcade', primary: '#f43f5e', accent: '#facc15', background: '#0d0221', surface: '#1a0b3b', border: '#3b1f6e' },
  { name: 'Dark Minimalist', primary: '#e5e7eb', accent: '#94a3b8', background: '#0a0a0a', surface: '#141414', border: '#262626' },
  { name: 'Classic Casino', primary: '#16a34a', accent: '#eab308', background: '#04140a', surface: '#0a2414', border: '#14532d' },
  { name: 'Synthwave', primary: '#ec4899', accent: '#f59e0b', background: '#12051f', surface: '#1e0b30' },
  { name: 'Matrix', primary: '#22c55e', accent: '#a3e635', background: '#020a04', surface: '#08160c' },
  { name: 'Oceano', primary: '#3b82f6', accent: '#2dd4bf', background: '#020617', surface: '#0b1628' },
  { name: 'Lava', primary: '#ef4444', accent: '#fb923c', background: '#0c0404', surface: '#1c0a0a' },
  { name: 'Oro Reale', primary: '#eab308', accent: '#f8fafc', background: '#0a0906', surface: '#17140c' },
];

const rgb = (hex) => { const n = parseInt(hex.slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; };
const mix = (c, t, w) => c.map((v, i) => Math.round(v + (t[i] - v) * w));
const SHADES = { 50: 0.92, 100: 0.84, 200: 0.68, 300: 0.48, 400: 0.24, 500: 0, 600: -0.16, 700: -0.32, 800: -0.48, 900: -0.6, 950: -0.74 };

function palette(name, hex) {
  const c = rgb(hex);
  return Object.entries(SHADES).map(([k, w]) => `--${name}-${k}: ${(w >= 0 ? mix(c, [255, 255, 255], w) : mix(c, [0, 0, 0], -w)).join(' ')};`).join('');
}

const loaded = new Set();
function loadFont(f) {
  if (!f || loaded.has(f) || f === 'JetBrains Mono' || f === 'Inter') return;
  loaded.add(f);
  const l = document.createElement('link');
  l.rel = 'stylesheet';
  l.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(f).replace(/%20/g, '+')}:wght@400;600;700;800&display=swap`;
  document.head.appendChild(l);
}

export function applyBrand(b) {
  [b.fontDisplay, b.fontUi, b.fontText].forEach(loadFont);
  let el = document.getElementById('brand-vars');
  if (!el) { el = document.createElement('style'); el.id = 'brand-vars'; document.head.appendChild(el); }
  el.textContent = `:root{${palette('violet', b.primary)}${palette('cyan', b.accent)}--t-bg-rgb: ${rgb(b.background).join(' ')};--t-surface-rgb: ${rgb(b.surface).join(' ')};--t-border-rgb: ${rgb(b.border || '#2a2350').join(' ')};--font-display: "${b.fontDisplay}", ui-monospace, monospace;--font-ui: "${b.fontUi}", ui-monospace, monospace;--font-text: "${b.fontText}", system-ui, sans-serif;}`;
  document.title = `${b.name} // ${b.tagline}`;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', b.primary);
}

export function cachedBrand() {
  try { return { ...DEFAULT_BRAND, ...(JSON.parse(localStorage.getItem('nexora.brand')) || {}) }; } catch { return DEFAULT_BRAND; }
}

export function brandName() { return cachedBrand().name; }
